// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__YG+vW","info_icons":"Footer_info_icons__Wsw0N","icons":"Footer_icons__0pc87","active":"Footer_active__KMEhk","tmp":"Footer_tmp__8KKO3"};